import styled from '@emotion/styled';
import * as colors from 'src/assets/colors';

export const AccountConfigContainer = styled('div', { label: 'AccountConfigContainer' })`
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
    font-family: var(--font-family-primary);
`;

export const AccountConfigWrapper = styled('div', { label: 'AccountConfigWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 1;
    max-width: 800px;
    margin: 0 24px;
    padding: 24px;
    background-color: ${colors.licenseConfig.bgColor};
`;
